var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 202 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 149c32.585 0 59-26.639 59-59.5 0-32.86-26.415-59.5-59-59.5S42 56.64 42 89.5c0 32.861 26.415 59.5 59 59.5Z",
    fill: "#002A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 136.759c25.881 0 46.862-21.159 46.862-47.26 0-26.1-20.981-47.258-46.862-47.258-25.88 0-46.861 21.159-46.861 47.259s20.98 47.259 46.861 47.259Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 45.707v5.794M101 127.857v5.794M144.602 89.68h-5.745M63.143 89.68h-5.745M124.024 52.334l-3.03 4.92M81.006 122.094l-3.03 4.92M138.021 112.898l-4.878-3.055M68.847 69.516l-4.879-3.056M139.076 68.251l-5.014 2.824M67.938 108.283l-5.014 2.824M122.247 128.078l-2.799-5.057M82.552 56.337l-2.8-5.057M77.977 68.251 101 89.5l18.448-10.619",
    stroke: "#B75C41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(42 30)",
    d: "M0 0h118v119H0z"
  })))));
};
export default SvgClock;